class ExportManager {
  constructor() {
    this.canvas = null;
  }

  setCanvas(canvas) {
    this.canvas = canvas;
  }

  getCanvas() {
    if (this.canvas) return this.canvas;
    const canvas = document.getElementById('main-canvas') || document.querySelector('canvas');
    if (!canvas) {
      console.error('Canvas not found in DOM');
      return null;
    }
    return canvas;
  }

  async generateImageBlob(format, quality, resolution) {
    const originalCanvas = this.getCanvas();
    if (!originalCanvas) throw new Error('Canvas not found');
    
    const tempCanvas = document.createElement('canvas');
    const tempCtx = tempCanvas.getContext('2d');
    
    const scaleFactor = resolution;
    tempCanvas.width = originalCanvas.width * scaleFactor;
    tempCanvas.height = originalCanvas.height * scaleFactor;
    
    tempCtx.scale(scaleFactor, scaleFactor);
    
    // Zawsze białe tło
    tempCtx.fillStyle = '#ffffff';
    tempCtx.fillRect(0, 0, originalCanvas.width, originalCanvas.height);
    
    tempCtx.drawImage(originalCanvas, 0, 0);
    
    return new Promise((resolve, reject) => {
      tempCanvas.toBlob(
        blob => blob ? resolve(blob) : reject(new Error('Failed to create blob')), 
        `image/${format === 'jpg' ? 'jpeg' : format}`, 
        quality
      );
    });
  }

  async exportToImage(format, quality, resolution) {
    const blob = await this.generateImageBlob(format, quality, resolution);
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `projekt-${Date.now()}.${format}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return blob;
  }

  getThumbnailDataUrl(width = 600) {
    const canvas = this.getCanvas();
    if (!canvas) return null;
    
    try {
      const tempCanvas = document.createElement('canvas');
      const scale = width / canvas.width;
      tempCanvas.width = width;
      tempCanvas.height = canvas.height * scale;
      const ctx = tempCanvas.getContext('2d');
      
      // Ensure white background for preview
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
      ctx.drawImage(canvas, 0, 0, tempCanvas.width, tempCanvas.height);
      
      return tempCanvas.toDataURL('image/jpeg', 0.8);
    } catch (e) {
      console.error("Thumbnail generation failed", e);
      return null;
    }
  }
}

const exportManager = new ExportManager();
export default exportManager;